export default [
  {
    portalGroup: 'collab.public',
    path: 'projects/:c0101_id/crowd-fund-tier/:c1101_id/pledge',
    name: 'PgC1301ProjectCrowdFundTierSelected',
    component: () => import('./PgC1301ProjectCrowdFundTierSelected'),
    meta: { title: '眾籌確認' }
  }
]
